module.exports = __webpack_public_path__ + "static/media/boy-16.76be5ab1.svg";